import { roadmapVisibilityConditionsSchema } from "src/stores/models/roadmap-visibility-conditions";
import { InferType, array, boolean, date, number, object, string } from "yup";

export enum TaskDefinitionType {
    DOCUMENT = "DOCUMENT",
    MANUAL = "MANUAL",
    TRAINING = "TRAINING",
    QUALITY_EVENT = "QUALITY_EVENT",
}

export enum TaskStateScope {
    DEVICE = "DEVICE",
    ORGANIZATION = "ORGANIZATION",
}

export const taskConfigSchema = object({
    taskType: string()
        .oneOf([TaskDefinitionType.DOCUMENT, TaskDefinitionType.MANUAL, TaskDefinitionType.TRAINING, TaskDefinitionType.QUALITY_EVENT])
        .required(),
    stateScope: string().oneOf([TaskStateScope.DEVICE, TaskStateScope.ORGANIZATION]).required(),
});

export type TaskConfig = InferType<typeof taskConfigSchema>;

const disabledTargetSchema = object({
    id: string().uuid().required(),
});

export const taskDefinitionSchema = object({
    id: string().uuid().required(),
    title: string().required(),
    taskKey: string().required(),
    parentCardKey: string().nullable().optional(),
    enabled: boolean().required(),
    order: number().nullable().optional(),
    visibilityConditions: roadmapVisibilityConditionsSchema.nullable().optional(),
    description: string().nullable().optional(),
    disabledForOrganizations: array().of(disabledTargetSchema).optional(),
    disabledForDevices: array().of(disabledTargetSchema).optional(),
    organizationId: string().uuid().nullable().optional(),
    deviceId: string().uuid().nullable().optional(),
    taskConfig: taskConfigSchema.required(),
    createdAt: date().required(),
    updatedAt: date().required(),
});

export type TaskDefinition = InferType<typeof taskDefinitionSchema>;

export const taskDefinitionsSchema = array().of(taskDefinitionSchema);

export type TaskDefinitions = InferType<typeof taskDefinitionsSchema>;

// Type alias for backward compatibility during migration
export type RoadmapTask = TaskDefinition;
export type RoadmapTasks = TaskDefinitions;
